import dayjs from 'dayjs'
import { z } from 'zod'

import { useFormWithZod } from '@/hooks/useFormWithZod'
const schema = () =>
  z.object({
    conditional_rule_groups: z.array(
      z.object({
        conditional_rules: z.array(
          z.object({
            type: z.string().optional(),
            question: z
              .string({ required_error: 'Question is required' })
              .min(1, 'Question is required'),
            operator: z
              .string({ required_error: 'Condition is required' })
              .min(1, 'Condition is required'),
            expected_answer: z
              .string()
              .optional()
              .or(z.array(z.string()).optional())
              .or(
                z.custom<dayjs.Dayjs>((val) =>
                  dayjs(val as unknown as string).isValid()
                )
              ),
          })
        ),
      })
    ),
    enabled: z.boolean().optional(),
    is_new: z.boolean().optional(),
    is_updated: z.boolean().optional(),
    id: z.string().optional(),
    form: z.string().optional(),
    packet: z.string().optional(),
    if_met: z.string(),
    order: z.number().nullable().optional(),
    url: z
      .string()
      .url('URL need start with https://')
      .refine((url) => url.startsWith('https://'), {
        message: 'URL need start with https://',
      })
      .nullish()
      .optional(),
    complete_page: z.string().nullish().optional(),
  })

export type FormAddConditionCompletePageModel = z.infer<
  ReturnType<typeof schema>
>

export const useAddConditionCompletePageForm = () => {
  const formAddConditionalCompletePageSchema = schema()
  const { form, rule } = useFormWithZod(formAddConditionalCompletePageSchema)
  return { form, rule, schema: formAddConditionalCompletePageSchema }
}
